"use client";
import { ReactNode } from "react";

import {
  LuSquarePen,
  LuDiamondPlus,
  LuChartPie,
  LuPalette,
  LuShapes,
  LuQrCode,
  LuLayoutGrid,
  LuLayoutDashboard,
} from "react-icons/lu";

import { MdRoundedCorner } from "react-icons/md";

export const UNIFIED_ICON_MAP = {
  LuSquarePen: <LuSquarePen />,
  LuDiamondPlus: <LuDiamondPlus />,
  LuChartPie: <LuChartPie />,
  LuPalette: <LuPalette />,
  LuLayoutDashboard: <LuLayoutDashboard />,
  LuShapes: <LuShapes />,
  LuQRcode: <LuQrCode />,
  LuLayoutGrid: <LuLayoutGrid className="icon-rotate-45" />,
  MdRoundedCorner: <MdRoundedCorner />,
} as const satisfies Record<string, ReactNode>;

export type UnifiedIconName = keyof typeof UNIFIED_ICON_MAP;

export const getUnifiedIcon = (icon?: UnifiedIconName | ReactNode) => {
  if (!icon) return undefined;
  return typeof icon === "string" ? UNIFIED_ICON_MAP[icon as keyof typeof UNIFIED_ICON_MAP] : icon;
};

// Legacy exports for backwards compatibility during migration
export { getUnifiedIcon as getAccordionIcon, getUnifiedIcon as getInputIcon };

export type AccordionIconName =
  | "LuSquarePen"
  | "LuDiamondPlus"
  | "LuChartPie"
  | "LuPalette"
  | "LuLayoutDashboard"
  | "LuShapes"
  | "LuQRcode"
  | "MdRoundedCorner"
  | "LuLayoutGrid";

export type InputIconName = "LuSquarePen";
